export default __webpack_public_path__ + "static/media/mountainside.8bea68dab9de327d65d478f7c15458d4.svg";